import Button from "@/Layouts/components/Buttons/Button";
import { Box, IconButton } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { ButtonsTabsProps } from "@/Layouts/types/ButtonTabsList/ButtonTabListItem";

interface Config {
	buttonSettings: ButtonsTabsProps[];
}

export const ListTabsButtons = (props: Config) => {
	const { buttonSettings } = props;

	const scrollRef = useRef<HTMLDivElement>();

	const [showChevrons, setShowChevrons] = useState(false);

	const scrollLeft = () => {
		if (scrollRef.current) {
			scrollRef.current.scrollBy({
				left: -200,
				behavior: "smooth",
			});
		}
	};
	const scrollRight = () => {
		if (scrollRef.current) {
			scrollRef.current.scrollBy({
				left: 200,
				behavior: "smooth",
			});
		}
	};

	useEffect(() => {
		const checkOverflow = () => {
			if (scrollRef.current) {
				const { scrollWidth, clientWidth } = scrollRef.current;
				setShowChevrons(scrollWidth > clientWidth);
			}
		};

		checkOverflow();
		window.addEventListener("resize", checkOverflow);

		return () => {
			window.removeEventListener("resize", checkOverflow);
		};
	}, [props]);

	return (
		<Box
			sx={{
				display: "flex",
				alignItems: "center",
				width: "100%",
			}}
		>
			{showChevrons && (
				<IconButton onClick={scrollLeft}>
					<ChevronLeft />
				</IconButton>
			)}
			<Box
				className="scrollable-list"
				ref={scrollRef}
				sx={{
					display: "flex",
					justifyContent: showChevrons ? "left" : "center",
					overflowX: "hidden",
					scrollBehavior: "smooth",
					width: "100%",
					margin: "10px 10px",
				}}
			>
				{buttonSettings.map((termsBtnInfo) => (
					<Button
						key={termsBtnInfo.id}
						onClick={() => termsBtnInfo.handleButtonSelector(termsBtnInfo.id)}
						variant="contained"
						text={termsBtnInfo.title}
						sx={{
							backgroundColor: termsBtnInfo.selected ? "white" : "var(--disabled-tabs-gray)",
							color: "var(--tab-gray-color)",
							fontFamily: "Montserrat",
							boxShadow: termsBtnInfo.selected ? "0px 2px 8px 0px #00000040" : "none",
							fontSize: 12,
							fontWeigth: 500,
							textTransform: "capitalize",
							minWidth: "fit-content",
							/* border: savedTabs.includes(termsBtnInfo._id) ? "1px solid red" : "1px solid transparent", */
							margin: "10px 10px",
							":hover": {
								backgroundColor: termsBtnInfo.selected ? "white" : "var(--disabled-tabs-gray)",
							},
						}}
					/>
				))}
			</Box>
			{showChevrons && (
				<IconButton onClick={scrollRight}>
					<ChevronRight />
				</IconButton>
			)}
		</Box>
	);
};
export default ListTabsButtons;
